export default {
  'get-list': {
    method: 'post',
    url: '/clienttrip/journey/list'
  },
  responseAllocation: {
    method: 'post',
    url: '/client/partner/trip/journey/allocation/response'
  },
  find: {
    method: 'get',
    url: '/clienttrip/journey/find?key=KEY'
  }
}
